module.exports = __webpack_public_path__ + "img/minus_btn.52ccb689.png";